import React, { Component } from "react";
import { ModuleAccordionGroup } from '@loanbossinc/component-library';
import { AccordionSection } from "component-lib/AccordionSection";
import { rows as sectionPropertyFinancialsRows } from './section-property-financials-rows';
import { rows as sectionPropertyDetailsRows } from './section-property-details-rows';
import { rows as sectionPropertyLocationRows } from './section-property-location-rows';
import moment from "moment";
import { PROPERTY_SECTION_KEYS } from '../property.constants';

export class PropertyGeneralInformation extends Component {
  getFinancialsSubTitle = () => {
    const { data } = this.props;
    const date = data.noiAsOfDate;

    if (!date) return null;
    return `As Of ${moment(date).format('MM/DD/YYYY')}`;
  }

  render() {
    const { data, propertyId, history, enableEditButton, ...other } = this.props;
    if (!data) return null;

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: 'General Information'
            , key: PROPERTY_SECTION_KEYS.GENERAL_INFORMATION
            , isTitleGroup: true
          }
          , {
            title: 'Property Financials'
            , key: PROPERTY_SECTION_KEYS.PROPERTY_FINANCIALS
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.PROPERTY_FINANCIALS}`)
            , subTitle: (() => this.getFinancialsSubTitle())()
            , sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionPropertyFinancialsRows} data={data} />
            ]
          }
          , {
            title: 'Property Details'
            , key: PROPERTY_SECTION_KEYS.PROPERTY_DETAILS
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.PROPERTY_DETAILS}`)
            , sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionPropertyDetailsRows} data={data} />
            ]
          }
          , {
            title: 'Location'
            , key: PROPERTY_SECTION_KEYS.LOCATION
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.LOCATION}`)
            , sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionPropertyLocationRows} data={data} />
            ]
          }
        ]}
      />
    );
  }
}
